import { useTranslation } from '@/i18n';
import {
  AtomListRowItem,
  ListRowItem as StatelessListRowItem,
} from '@moneyforward/ap-frontend-components';
import classnames from 'classnames';
import { FC, memo } from 'react';
import styles from './ApplicationDetailRow.module.scss';

const cx = classnames.bind(styles);

export type ApplicationDetailHeaderProps = {
  allChecked: boolean;
  indeterminate: boolean;
  onToggleAll: () => void;
};

const InnerApplicationDetailHeader: FC<ApplicationDetailHeaderProps> = ({
  allChecked,
  indeterminate,
  onToggleAll,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cx(styles['list-row-row'])}>
      <AtomListRowItem
        containerClassName={cx(styles['list-row-th'])}
        testId='header-empty'
        title=''
        type='header'
        transparent
      />
      <AtomListRowItem
        containerClassName={cx(styles['list-row-before'])}
        testId='body-text-5'
        title={t('application_form_reflection_data_before')}
        type='header'
      />
      <div className={cx(styles['list-row-icon-column-header'])} />
      <StatelessListRowItem
        containerClassName={cx(styles['list-row-after'])}
        inputId='header-checkbox'
        label={t('application_form_reflection_data_after')}
        type='header'
        checked={allChecked}
        indeterminate={indeterminate}
        onChange={onToggleAll}
      />
    </div>
  );
};

InnerApplicationDetailHeader.displayName = 'InnerApplicationDetailHeader';

export const ApplicationDetailHeader: FC<ApplicationDetailHeaderProps> = memo(
  InnerApplicationDetailHeader
);
